import { trpc } from "#/lib/trpc/client"
import { PhotoIdImage } from "@internal/telemedicine"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { photoIdOnFileQueryKey } from "./usePhotoIdOnFile"

export function useUploadIdDocuments() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (images: { front: PhotoIdImage; back: PhotoIdImage }) =>
      trpc.telemedicine.uploadIdDocuments.mutate(images),
    // A successful upload means a complete ID is on file — reconcile the cached status so returning to
    // the page (after the mutation's in-memory success state is gone) doesn't show the uploader again.
    onSuccess: () => {
      queryClient.setQueryData(photoIdOnFileQueryKey, { onFile: true })
    }
  })
}
